import { useQuery } from '@tanstack/react-query';

import { fetchTeamFixturesPreview } from '@api-service/team-fixtures-preview';
import type {
  TeamFixturesPreviewParameters,
  TeamWithFixturePreview
} from '@api-service/team-fixtures-preview';

const FIVE_MINUTES_IN_MS = 5 * 60 * 1000;

export type UseTeamFixturesPreviewResult = {
  teams: TeamWithFixturePreview[];
  isLoading: boolean;
  isFetching: boolean;
  isError: boolean;
};

export const useTeamFixturesPreview = (
  parameters: TeamFixturesPreviewParameters
): UseTeamFixturesPreviewResult => {
  const isRangeValid =
    parameters.gameweekStart >= 1 &&
    parameters.gameweekEnd >= parameters.gameweekStart;

  const { data, isLoading, isFetching, isError } = useQuery({
    queryKey: ['team-fixtures-preview', parameters],
    queryFn: () => fetchTeamFixturesPreview(parameters),
    enabled: isRangeValid,
    staleTime: FIVE_MINUTES_IN_MS,
    keepPreviousData: true,
    refetchOnWindowFocus: false
  });

  return {
    teams: data ?? [],
    isLoading: isLoading && isRangeValid,
    isFetching,
    isError
  };
};
